<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Insights
            </v-row>
            <!--table head-->
            <v-divider />
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" class="tabCell" 
                    :class="item.style"
                    :cols="item.cols">
                    {{ item.title }}
                </v-col>
            </v-row>
            <div v-if="insights?.length">
                <!--media-costs row-->
                <div v-for="item in insights" :key="item.id">
                    <v-row no-gutters>
                        <v-col cols="1" class="tabCell text-left">{{ item?.id }}</v-col>
                        <v-col cols="1" class="tabCell text-center">{{ item.segment?.name }}</v-col>
                        <v-col cols="1" class="tabCell text-center">{{ item.weight }}</v-col>
                        <v-col cols="8" class="tabCell text-center">{{ item.text }}</v-col>                        
                        <v-col cols="1" class="tabCell text-right">
                            <edit-insight :insight="item" />
                            <delete-insight :insight="item" />
                        </v-col>
                    </v-row>
                </div>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You don't have insight yet!
            </v-row>

        </div>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import EditInsight from '../../../components/admin/insights/editInsight.vue';
import DeleteInsight from '../../../components/admin/insights/deleteInsight.vue';

export default {
    name: 'Insights',
    data() {
        return {
            headers: [
                { title: 'Id', style: 'text-left', cols: 1 },
                { title: 'Segment', style: 'text-center', cols: 1 },
                { title: 'Weight', style: 'text-center', cols: 1 },
                { title: 'Insight', style: 'text-center', cols: 8 },
                { title: 'Action', style: 'text-right', cols: 1 },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        insights() {
            return this.$store.getters.insights;
        },

    },
    methods: {
    },
    components: {
        Loader, EditInsight, DeleteInsight
    }
}
</script>